import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getAnalytics, logEvent as firebaseLogEvent } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyBVHeFwRpbSAxA3LSRzx8TZS9aU2S8jyE4",
  authDomain: "moveoftoday.firebaseapp.com",
  projectId: "moveoftoday",
  storageBucket: "moveoftoday.firebasestorage.app",
  messagingSenderId: "216699905300",
  appId: "1:216699905300:web:98aa78f83b9aa067ad4e01",
  measurementId: "G-X6GWP0N402"
};

const app = initializeApp(firebaseConfig);

// Analytics 초기화 (에러 처리)
let analytics = null;
try {
  if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
    console.log('✅ Firebase Analytics initialized');
  }
} catch (error) {
  console.warn('⚠️ Analytics not available:', error.message);
  // Analytics 없이도 앱 작동
}

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export { analytics };

// 안전한 logEvent 함수
export const logEvent = (analyticsInstance, eventName, eventParams) => {
  if (analyticsInstance) {
    try {
      firebaseLogEvent(analyticsInstance, eventName, eventParams);
    } catch (error) {
      console.warn('Analytics event failed:', eventName, error);
    }
  }
};